import { ApiProperty } from '@nestjs/swagger';
import { IsNumber, Min } from 'class-validator';

/**
 * Represents the result of a deal price calculation.
 * Typically used in pricing endpoints to return the final computed cost.
 */
export class DealCalcPriceResponse {
  @ApiProperty({
    description: 'Final calculated deal price in rubles. May include taxes, fees, and discounts.',
    example: 12999.5,
    type: Number,
    format: 'float',
    minimum: 0,
    maximum: 100000000,
    nullable: false,
  })
  @IsNumber()
  @Min(0)
  price: number;
}
